import React from 'react';

export default function ContentWithTopLabel(props) {
    return (
        <div className="filter-group ">
            <div className="filter-group-header">
                <span className="checkbox-wrapper">{props.label}</span>
            </div>
            <div className="filter-group-content">
                {props.children}
            </div>
        </div>
    )
}